import { render, staticRenderFns } from "./horizontal_main.vue?vue&type=template&id=c9a6ec42&scoped=true&"
import script from "./horizontal_main.vue?vue&type=script&lang=js&"
export * from "./horizontal_main.vue?vue&type=script&lang=js&"
import style0 from "./horizontal_main.vue?vue&type=style&index=0&id=c9a6ec42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a6ec42",
  null
  
)

export default component.exports